import { Text, TextProps } from "@jsq/ds/core";
import { Details, subtitleSeparator } from "../styles_vanilla.css";
import { PositionPropsType, SourceCaseType } from "../types";
import EscalationDetail from "./EscalationDetail";
import PositionDetail from "./PositionDetail";

type Props = Omit<TextProps, "children"> & {
  detail: string | number | null | undefined;
  sourceCase?: SourceCaseType;
  positionProps?: PositionPropsType;
  showSeparator?: boolean;
};

const SecondaryDetail = ({
  detail,
  sourceCase,
  positionProps,
  showSeparator = false,
  ...rest
}: Props) => {
  const renderDetailContent = () => {
    switch (detail) {
      case "Escalation":
        return <EscalationDetail detail={detail} sourceCase={sourceCase} {...rest} />;
      case "Position":
        return <PositionDetail positionProps={positionProps} />;
      default:
        return (
          <Text variant="regular-sm" {...rest} className={Details} asSpan>
            {detail}
          </Text>
        );
    }
  };

  return (
    <>
      {renderDetailContent()}
      {showSeparator ? (
        <Text variant="regular-sm" asSpan className={subtitleSeparator}>
          |
        </Text>
      ) : null}
    </>
  );
};

export default SecondaryDetail;
